React = require 'react'
Auth = require 'db/auth'
Controller = require 'controller'
Storage = require 'lib/storage'
t = require('views/internal/recup-with-helpers')()
{ FeedbackLink } = require './presentational/feedback-link'
{ FeatureFeedbackLink } = require './presentational/feature-feedback-link'
StickyBoxWaitForMount = require 'views/lib/sticky-box-wait-for-mount'
trackUe = require 'debug/trackUe'
HomeLeftSidebarContainer = require 'views/home/home-left-sidebar-container'
HomeMainContentContainer = require 'views/home/home-main-content-container'
HomeRightSidebarContainer = require 'views/home/home-right-sidebar-container'

module.exports = class HomeContainer extends React.Component
  displayName: 'HomeContainer'

  constructor: (props) ->
    super props

    @dismissTeamBoardsFeedbackLink = @dismissTeamBoardsFeedbackLink.bind(@)

  dismissTeamBoardsFeedbackLink: ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    trackUe('home', 'dismisses', 'team boards feedback link', '', 'on team boards tab', 'by clicking dismiss in team boards feedback link', { teamId: orgId })
    Auth.me().dismiss('homeTeamBoardsFeedbackLink')

  render: t.renderable ->
    { modelCache, model, orgname, allBoards, orgBoards, setFocusedCard, orgCards } = @props

    t.div '.home-container', =>
      t.createElement FeedbackLink, {
        idMember: Auth.me().id
        isFloating: true
      }
      t.div '.sticky-spacer', =>
        t.div '.home-sticky-container', =>
          t.tag StickyBoxWaitForMount, {
            className: 'sticky-spacer'
          }, =>
            t.tag HomeLeftSidebarContainer, {
              modelCache
              model
              orgname
              allBoards
              orgBoards
            }
          if allBoards
            t.div '.all-boards', ->
              t.tag StickyBoxWaitForMount, {
                className: 'sticky-spacer'
              }, =>
                t.div '.content-all-boards', =>
                  allBoards()
          else if orgBoards
            t.div '.all-boards', =>
              t.tag StickyBoxWaitForMount, {
                className: 'sticky-spacer'
              }, =>
                t.div '.content-all-boards', =>
                  if !Auth.me().isDismissed('homeTeamBoardsFeedbackLink')
                    t.tag FeatureFeedbackLink, {
                      feedbackLinkUrl: "https://trello.typeform.com/to/yCCWjK?memberid=#{Auth.me().id}"
                      onFeedbackLinkClick: @dismissTeamBoardsFeedbackLink
                      onDismissIconClick: @dismissTeamBoardsFeedbackLink
                    }
                  orgBoards()
          else if orgCards
            t.div '.all-boards', =>
              t.div '.content-all-boards', =>
                orgCards()
          else
            t.div '.sticky-spacer', =>
              t.tag HomeMainContentContainer, {
                modelCache
                orgname
                setFocusedCard
              }
            t.tag StickyBoxWaitForMount, {
              className: 'sticky-spacer'
            }, =>
              t.tag HomeRightSidebarContainer, {
                modelCache
                model
                orgname
              }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-container.coffee